import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '~/context/registration';
import { useToasts } from 'react-toast-notifications';

import { setCampaignCost } from '~/services/registration';

import { currencyConfig } from '~/shared/components/form/Inputs';
import { ProgressBar } from '../ProgressBar';
import IntlCurrencyInput from 'react-intl-currency-input';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';

import { SelectOption } from '~/types/globals';
import { fetchMedicalExpenseTypes } from '~/services/options';
import { Loading } from '~/shared/components/Loading';

export const Cost = ({}: any) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [isSelfCampaign, setIsSelfCampaign] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [expenseTypeOptions, setExpenseTypeOptions] = useState<
        SelectOption[]
    >([]);
    const [selectedExpenseCodes, setSelectedExpenseCodes] = useState([]);
    const [anticipatedCost, setAnticipatedCost] = useState('');
    const [nonSelectedError, setNonSelectedError] = useState('');

    const { addToast } = useToasts();
    const history = useHistory();

    console.log('selected', selectedExpenseCodes);

    const getMedicalExpenseTypes = async () => {
        const resp = await fetchMedicalExpenseTypes();
        console.log('resp: ', resp);
        const opts = resp.map((opt, i) => {
            return {
                label: opt.name,
                value: opt.code,
            };
        });
        setExpenseTypeOptions(opts);
        setLoading(false);
    };

    useEffect(() => {
        getMedicalExpenseTypes();
    }, []);

    const handleSubmit = async () => {
        try {
            const isValid = anticipatedCost && selectedExpenseCodes.length > 0;
            if (isValid) {
                setSaving(true);
                let optPayload = {};
                expenseTypeOptions.map((opt) => {
                    const isSelected = selectedExpenseCodes.includes(opt.value);

                    optPayload[opt.value] = isSelected;
                });
                console.log('optPayload: ', optPayload);

                const resp = await setCampaignCost(optPayload, anticipatedCost);
                console.log('resp: ', resp);

                registrationDispatch({
                    type: 'set_application',
                    application: resp,
                });
                history.push('/get-started/financials/contribution');
            } else {
                setNonSelectedError(
                    'Please select at least one option from below'
                );
            }
        } catch (e) {
            console.log('e: ', e);
            setSaving(false);
        }
    };

    if (loading) {
        return <Loading />;
    }

    const pronoun = isSelfCampaign ? 'your' : 'their';

    const handleOptSelect = (opt) => {
        let newSelected = selectedExpenseCodes;
        if (selectedExpenseCodes.includes(opt.value)) {
            newSelected = selectedExpenseCodes.filter(
                (x) => x.value !== opt.value
            );
        } else {
            newSelected = [...selectedExpenseCodes, opt.value];
        }
        setSelectedExpenseCodes(newSelected);
    };

    const isValid = anticipatedCost && selectedExpenseCodes.length > 0;

    return (
        <Container>
            <ProgressBar selectedStep='financials' />

            <Form>
                <Row className='justify-content-center py-5'>
                    <Col md='9'>
                        <div className='text-center'>
                            <h3>
                                What are the costs associated with {pronoun}{' '}
                                situation?
                            </h3>
                        </div>
                        <p className='text-center' style={{ color: 'red' }}>
                            {nonSelectedError}
                        </p>

                        <Card
                            className='box-shadow my-5'
                            style={{
                                maxWidth: '1000px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            <CardBody>
                                <legend>
                                    Please check all their anticipated
                                    out-of-pocket medical and related expenses.*
                                </legend>
                                <FormGroup check className='mb-3 three-cols'>
                                    {expenseTypeOptions.map((opt, i) => {
                                        return (
                                            <div key={i}>
                                                <Label check>
                                                    <Input
                                                        type='checkbox'
                                                        value={opt.value}
                                                        onClick={() =>
                                                            handleOptSelect(opt)
                                                        }
                                                        name='medical_expense_types'
                                                    />
                                                    {opt.label}
                                                </Label>
                                            </div>
                                        );
                                    })}
                                </FormGroup>
                                <FormGroup>
                                    <Label>Anticipated Cost*</Label>
                                    <IntlCurrencyInput
                                        onChange={(e, val, masked) => {
                                            setAnticipatedCost(val);
                                        }}
                                        className='form-control'
                                        config={currencyConfig}
                                    />
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <div className='text-center mb-5'>
                    <Button
                        color='outline-dark'
                        disabled={saving}
                        onClick={() =>
                            history.push(
                                '/get-started/condition/medical-professional'
                            )
                        }
                    >
                        Back
                    </Button>
                    <Button
                        color='primary'
                        // disabled={!isValid || saving}
                        onClick={handleSubmit}
                    >
                        {saving ? `Saving...` : `Next`}
                    </Button>

                    <div className='mt-4'>
                        <Button color='link'>Skip for Now</Button>
                        <p>
                            You will be required to provide this information in
                            order to receive any funds raised for this campaign.
                        </p>
                    </div>
                </div>
            </Form>
        </Container>
    );
};
